import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import translation from "../i18n/translation";

const resources = translation;

i18n
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en", // Fallback if detected language is missing
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
    detection: {
      order: [ 'cookie', 'navigator', 'querystring', 'htmlTag'],
      caches: ['cookie'],
    }
  });

// console.log("Detected language:", i18n.language);

export default i18n;
